module.exports = __webpack_public_path__ + "img/mix-2.b98d6ce1.webp";